import UgcEditorConstants from '../constants/UgcEditorConstants';

export function openEditor(ugcType) {
  return {
    type: UgcEditorConstants.OPEN_EDITOR,
    ugcType,
    middlewareData: {
      authRequired: true
    }
  };
}

export function closeEditor(ugcType) {
  return {
    type: UgcEditorConstants.CLOSE_EDITOR,
    ugcType
  };
}

export default {
  openEditor,
  closeEditor
};
